import { Component, Input } from '@angular/core';

export type SubscriptionContext = 'organization' | 'user';

@Component({
    selector: 'app-subscriptions-page',
    templateUrl: './subscriptions-page.component.html',
    styleUrl: './subscriptions-page.component.scss',
    standalone: false,
})
export class SubscriptionsPageComponent {
    @Input() context: SubscriptionContext;
    @Input() userId: string;
    @Input() activeOrganization: string;

    get showSubscriptions(): boolean {
        const isInOrganizationContext = !!this.activeOrganization;

        return this.context === 'organization'
            ? isInOrganizationContext
            : !isInOrganizationContext;
    }

    get placeholderMessageKey(): string {
        return this.context === 'organization'
            ? 'shared.components.subscriptionsPage.placeholderMessages.organization'
            : 'shared.components.subscriptionsPage.placeholderMessages.user';
    }
}
